(function(root){
  'use strict';
  const config=root.DB_COMMERCE||{products:{},assets:{}};
  const definitions=[
    {id:'original',name:'Darts Babes Calendar 2027',price:2499,compare:2999,savings:[0,699,1498]},
    {id:'xxl',name:'XXL Calendar 2027',price:4999,compare:5999,savings:[0,1499,3498]}
  ];
  function makeCatalog(data=config){return definitions.map(base=>{
    const product=data.products?.[base.id],variant=product?.variants?.find(v=>v.available)||product?.variants?.[0];
    return {...base,name:root.DB_I18N?.t(base.name)||base.name,price:variant?.price??base.price,compare:variant?(variant.compare_at_price||null):base.compare,
      variantId:variant?.id||null,available:!!variant?.available,connected:!!variant,thumb:data.assets?.[base.id+'-thumb.webp']||'',product};
  });}
  const CATALOG=makeCatalog();
  function edition(id){const item=CATALOG.find(item=>item.id===id);if(!item)throw new RangeError('Unknown calendar');return item;}
  function quantity(value){const count=Number(value);if(!Number.isInteger(count)||count<1||count>99)throw new RangeError('Choose a quantity between 1 and 99.');return count;}
  function quote(id,value){const item=edition(id),count=quantity(value),saving=item.savings[Math.min(count,3)-1],total=item.price*count-saving,reference=item.compare?item.compare*count:total;
    return {item,quantity:count,total,saving,each:total/count,compare:reference>total?reference:null,reduction:reference>total?Math.round((1-total/reference)*100):0};
  }
  function autographVariant(data=config){return data.autograph?.variants?.find(v=>v.available)||data.autograph?.variants?.[0]||null;}
  function autographAvailable(data=config){const variant=autographVariant(data);return !!variant?.available&&variant.price===0;}
  function editionForLine(line){return CATALOG.find(item=>item.variantId&&String(item.variantId)===String(line.variant_id));}
  function isAutograph(line,data=config){return String(line.variant_id)===String(autographVariant(data)?.id)||line.handle===(data.autographHandle||'viktoria-autograph-card');}
  function isRetiredLine(line,data=config){return (data.retiredVariantIds||[]).some(id=>String(id)===String(line.variant_id))||(data.retiredHandles||[]).includes(line.handle);}
  function cartMatches(cart,data=config){
    if(cart.currency!=='EUR')return false;
    const groups={};let cards=0;
    for(const line of cart.items||[]){
      if(isRetiredLine(line,data))return false;
      if(!Number.isInteger(line.quantity)||line.quantity<1)return false;
      if(isAutograph(line,data)){cards+=line.quantity;if(line.final_line_price!==0)return false;continue;}
      const item=editionForLine(line);if(!item)return false;
      const group=groups[item.id]||(groups[item.id]={quantity:0,total:0});group.quantity+=line.quantity;group.total+=line.final_line_price;
    }
    const count=Object.values(groups).reduce((sum,g)=>sum+g.quantity,0);
    if(cards>1||(!count&&cards))return false;
    if(count&&autographAvailable(data)&&cards!==1)return false;
    if(cards&&!autographAvailable(data))return false;
    for(const [id,group] of Object.entries(groups)){
      if(!Number.isInteger(group.total)||group.total<0)return false;
      try{if(group.total>quote(id,group.quantity).total)return false;}catch{return false;}
    }
    return true;
  }
  const api={CATALOG,makeCatalog,edition,quantity,quote,autographVariant,autographAvailable,editionForLine,isAutograph,isRetiredLine,cartMatches};
  if(typeof module!=='undefined'&&module.exports)module.exports=api;else root.DB_SHOP=api;
})(typeof window!=='undefined'?window:globalThis);
